export const CategoriesTypeEnum = {
    TabView : 1,        //  Extend View (On mobile scroll)
    SlideView : 2,      //  List View (On mobile slider)
    ListView : 3        //  Dropdown View(On mobile bottomsheet)
}